/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const fullPageModalTokens = {
  CoreBackgroundColor: '#ffffff',
  CoreBorderHeader: '1px solid #dedfdf',
  CoreBorderActions: '1px solid #ebecec',
  CoreElevationZindexWrapper: '999', // will be revisited
  CoreElevationZindexBackdrop: '1000', // will be revisited
  CoreElevationZindexContent: '1001', // will be revisited
  CoreElevationZindexHeader: '1002', // will be revisited
  CoreElevationShadow: '0px 1px 5px 1px #dedfdf',
  CoreIconColor: '#656b6b',
  CoreSizeFull: '100%',
  CoreSizeHeader: '68px',
  CoreSpacingContentVertical: '32px',
} as const;
